import { useEffect } from 'react'
import { useNotificationCount } from '../hooks/useNotificationCount'
import { applyTabBadge } from '../lib/tabBadge'

/**
 * Headless component: reflects the shared unread-notification count onto the
 * browser tab (title prefix + favicon badge), so unread items are noticeable
 * when Code Concierge is in a background tab. Renders nothing.
 *
 * The count itself is polled by NotificationBell (mounted in Layout); this
 * component only mirrors the latest value onto the tab.
 */
export function TabNotificationBadge() {
  const { unreadCount } = useNotificationCount()

  useEffect(() => {
    applyTabBadge(unreadCount)
  }, [unreadCount])

  return null
}
